export const envConfig = {
  HOST: import.meta.env.VITE_HOST,
  API_URL: import.meta.env.VITE_API_URL,
  WS_URL: import.meta.env.VITE_WS_URL,
  MEDIA_URL: import.meta.env.VITE_MEDIA_URL,
  GA_ID: import.meta.env.VITE_GA_ID,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  // Dev deploys build in production mode (IN_DEV=false) but hit the dev API, so
  // IN_DEV can't separate them in Sentry — both end up tagged "production".
  // Key off the API host instead so dev/prod errors are distinguishable.
  // NOTE: use a plain `===` on the inlined env var, NOT a method call like
  // `?.includes()` — the minifier miscompiled the optional-chained call on the
  // define-inlined constant into `(void 0)(...)`, which threw at module load and
  // 500'd every SSR route. A `===` comparison constant-folds to a boolean safely.
  SENTRY_ENVIRONMENT:
    import.meta.env.VITE_API_URL === 'https://dev.teamplay.gg/graphql'
      ? 'development'
      : 'production',
  // Google Tag Manager ships in every build, so dev.teamplay.gg and every E2E run land in the
  // production GA4 property — that is why GA reports many times more signups than the product
  // database has users. Analytics now loads only when the app talks to the production API.
  // Set VITE_ANALYTICS_ENABLED=true on a dev build when tags themselves need testing.
  ANALYTICS_ENABLED:
    import.meta.env.VITE_ANALYTICS_ENABLED === 'true' ||
    import.meta.env.VITE_API_URL === 'https://teamplay.gg/graphql',
  RECAPTCHA_KEY: import.meta.env.VITE_RECAPTCHA_KEY,
  IN_DEV: import.meta.env.DEV,
  // True in the Capacitor native shell builds (`--mode native` and `--mode nativeprod`).
  // Used to skip web-only concerns that misbehave from the `https://localhost`
  // app origin (e.g. Sentry ingest, which has no CORS grant for that origin).
  //
  // Driven by VITE_IS_NATIVE (set in .env.native / .env.nativeprod), NOT by the mode
  // name: `MODE === 'native'` folded to false in the prod app build, which silently
  // disabled every native code path — native auth included, so that build could not
  // even log in. Keep the `=== 'true'` comparison: it constant-folds, which is what
  // tree-shakes the Capacitor imports out of the web bundle (see the note on
  // SENTRY_ENVIRONMENT above for why a method call here would be miscompiled).
  IS_NATIVE: import.meta.env.VITE_IS_NATIVE === 'true',
  IOS_NATIVE_CALLS: import.meta.env.VITE_IOS_NATIVE_CALLS === 'true',
  IN_BROWSER: typeof window !== 'undefined',
  IN_SERVER: typeof window === 'undefined',
  DEV_BADGE: import.meta.env.VITE_DEV_BADGE === 'true',
  SENTRY_URL: import.meta.env.VITE_SENTRY_URL,
  IMGPROXY_ENABLED: import.meta.env.VITE_IMGPROXY_ENABLED === 'true',
  IMGPROXY_URL: import.meta.env.VITE_IMGPROXY_URL,
  IMGPROXY_KEY: import.meta.env.VITE_IMGPROXY_KEY,
  IMGPROXY_SALT: import.meta.env.VITE_IMGPROXY_SALT,
} as const;
